<template>
  <div>
    <div class="head">
      <span class="setting" @click="openSetting">
        <i class="el-icon-setting" style="margin-right: 5px"></i>工资凭证设置
      </span>
    </div>
    <div class="container acc_flex">
      <div class="item" v-for="(item,i) in list" :key="i">
        <span>{{item.name}}</span>
        <span class="item_b">
            <span v-if="item.state==0" style="color:#268aff">
               <span v-for="(child,childI) in item.list" :key="childI" @click="handleClickDialogShow(child)">
                {{`${child.word}_${child.number}`}}
               </span>
                
            </span>
            <span v-if="item.state==2" @click="handleClickDialogPreview(item)" style="color:red;">
                {{item.money}}
            </span>
        </span>
      </div>
    </div>
    <!-- 凭证设置-->
    <VoucherSetting ref="voucherSetting" />
     <!-- 修改凭证  -->
    <edit-voucher
      :visible.sync="XG_voucherShow"
      :row="rows"
      :voucherTitle="voucherTitle"
      @on-close-dialog="cancel"
      @on-success-submit="successEdit"
      :openButton_s="openButton_s"
      v-if="XG_voucherShow"
    ></edit-voucher>
  </div>
</template>

<script>
import editVoucher from "@/components/table/editVoucher";
import VoucherSetting from "./VoucherSetting.vue";
import { getAccruedSalary } from "@/api/index.js";
export default {
  components: {
    VoucherSetting,
    editVoucher
  },
  computed:{
    // 获取会计期间开始时间
    nowYearPeriod() {
			return JSON.parse(sessionStorage.getItem('accountInfo')).nowYearPeriod;
		},
  },
  data() {
    return {
      voucherTitle:'',
      rows:'',
      openButton_s:false,
      XG_voucherShow:false,
      list: [],
    };
  },
  mounted(){
    this.qeuryAccruedSalary()
  },
  methods: {
    handleClickDialogShow(row) {
      this.rows = row;
      this.voucherTitle = '修改凭证'
      this.XG_voucherShow = true;
      this.openButton_s = true;
    },
    handleClickDialogPreview(item) { 
      let _row = item.voucherChiefVo;
      _row.voucherAddendumVoList = _row.voucherAddendumVoList;
      _row.selfNumber = _row.number
      _row.date = this.$util.formatDate.format(_row.date,'yyyy-MM-dd');
      _row.isGenerate = true;
      console.log(_row);
      this.voucherTitle = '新增凭证'
      this.rows = _row;
      this.XG_voucherShow = true;
      this.openButton_s = true;
    },
    successEdit(val) {
      //修改成功后的回调
      if (val) {
        this.qeuryAccruedSalary();
      }
    },
    // 关闭弹框
    cancel(val) {
      this.XG_voucherShow = val;
      this.openButton_s = false;
    },
    //获取计提发放
    qeuryAccruedSalary() {
      getAccruedSalary({yearPeriod:this.nowYearPeriod}).then(res=>{
        if(res.data.code==1){
            console.log(res.data.data)
            this.list = res.data.data
        }
      })
    },
    openSetting() {
      this.$refs.voucherSetting.openTask();
    },
  },
};
</script>

<style lang="less" scoped>
.head {
  width: 100%;
  text-align: right;
  font-size: 14px;
  color: #269d7b;
  .setting {
    cursor: pointer;
  }
}
.container {
  margin-top: 15px;
  flex-wrap: wrap;
  .item {
    border: 1px solid #eee;
    flex-direction: column;
    padding: 20px 30px;
    display: flex;
    border-radius: 4px;
    align-items: center;
    justify-content: center;
    margin-right: 30px;
    margin-bottom: 20px;
    width: 200px;
    box-sizing: border-box;
    .item_b {
      margin-top: 5px;
      font-weight: bold;
      cursor: pointer;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/salary/components/AccrualGrant.vue